import React from "react";
import classes from "./NullSearchResults.module.scss";

interface NullSearchResultsProps {

}

const NullSearchResults: React.FC<NullSearchResultsProps> = () => {
   return <div className={classes.container}>
      <div>
         We didn't find any spaces for your selected day and time.
         <br />
         Try adjusting your filters or selecting a different day and time.
      </div>
   </div>
}

export default NullSearchResults;